var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNuxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 92.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}.cls-2{fill:#000;}.cls-3{fill:#000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nuxt-js") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.15,25.38,65.94,32.8,51.53,7.42,7.29,85.31h30a7.36,7.36,0,0,0,7.3,7.42H7.29A7.26,7.26,0,0,1,1,89,7.5,7.5,0,0,1,1,81.6L45.21,3.71a7.24,7.24,0,0,1,12.64,0l12.3,21.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.08,81.6,74.37,32.8l-4.22-7.42L65.94,32.8,38.22,81.6a7.55,7.55,0,0,0,0,7.42,7.27,7.27,0,0,0,6.32,3.71H95.76A7.27,7.27,0,0,0,102.08,89a7.55,7.55,0,0,0,0-7.42ZM44.54,85.31l25.61-45.1,25.61,45.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.9,89a7.26,7.26,0,0,1-6.31,3.71H95.76a7.35,7.35,0,0,0,7.29-7.42h12.52L80.06,22.77l-5.69,10-4.22-7.42,3.59-6.32a7.24,7.24,0,0,1,12.64,0L121.9,81.6a7.5,7.5,0,0,1,0,7.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNuxt);
export default __webpack_public_path__ + "static/media/icon-nuxt.2ad840b09180037898765128b1d0540e.svg";
export { ForwardRef as ReactComponent };